import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Row, Col, FormGroup, Label, Input } from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

// import Select from "react-select";
import moment from "moment";

import {
  getUserLocations,
  getUserSubLocations,
  getUserDepartment,
} from "../../store/Mini/actions";
import {
  FiltershideRightSidebar,
  FilterChangeValue,
  FilterSelectChangeValue,
  SetParams,
  getRFQRequestList,
  FilterClear,
} from "../../store/RequetForQuotation/actions";

import "./filtersRightbar.scss";
class FiltertRightbar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hideFilterRightbar = this.hideFilterRightbar.bind(this);

    this.FilterChangeHandeler = this.FilterChangeHandeler.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
  }
  componentDidMount() {
    this.props.getUserLocations();
    this.props.getUserDepartment();
  }

  /**
   * Hides the right sidebar
   */
  hideFilterRightbar(e) {
    e.preventDefault();
    this.props.FiltershideRightSidebar();
  }

  FilterChangeHandeler(e) {
    this.props.FilterChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  applyFilter() {
    this.props.getRFQRequestList({
      ...this.props.params,
      page: 1,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? ""
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
    });

    this.props.FiltershideRightSidebar();
  }
  clearFilter() {
    this.props.SetParams({
      ...this.props.params,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      sublocation: "",
      location: "",
    });

    this.props.getRFQRequestList({
      ...this.props.params,
      page: 1,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      sublocation: "",
      location: "",
    });

    this.props.FilterClear();
    this.props.FiltershideRightSidebar();
  }

  render() {
    return (
      <React.Fragment>
        <div className="filters-right-bar">
          <div className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={this.hideFilterRightbar}
                className="right-bar-toggle float-right"
              >
                <i className="mdi mdi-close noti-icon"></i>
              </Link>
              <h5 className="m-0">Filters</h5>
            </div>
            <hr className="my-0" />
            <SimpleBar style={{ maxHeight: "100%" }}>
              <div className="px-3 py-4">
                <Row>
                  <Col md={12} className="mb-0">
                    <FormGroup className="mb-0 pb-0">
                      <Label
                        htmlFor="validationFromDate"
                        className="col-form-label"
                      >
                        From Date:
                      </Label>

                      <Input
                        className="mb-0 form-control "
                        type="date"
                        value={this.props.params?.start_date}
                        onChange={this.FilterChangeHandeler}
                        id="CProduct-Name-text-input"
                        name="start_date"
                        placeholder="select Date"
                        max={moment(new Date()).format("YYYY-MM-DD")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12} className="mb-0">
                    <FormGroup className="mb-0 pb-0">
                      <Label
                        htmlFor="validationToDate"
                        className="mb-0 col-form-label"
                      >
                        To Date:
                      </Label>

                      <Input
                        className="mb-0 form-control "
                        type="date"
                        value={this.props.params?.end_date}
                        onChange={this.FilterChangeHandeler}
                        id="CProduct-Name-text-input"
                        name="end_date"
                        placeholder="select Date"
                        disabled={
                          this.props.params.start_date === "" ? true : false
                        }
                        min={moment(this.props.params?.start_date).format(
                          "YYYY-MM-DD"
                        )}
                        max={moment(new Date()).format("YYYY-MM-DD")}
                      />
                    </FormGroup>
                  </Col>
                  {/* <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label
                        htmlFor="Location-selection"
                        className="col-form-label"
                      >
                        Locations :
                      </Label>

                      <Select
                        id="Department-selection"
                        name="Department-selection"
                        classNamePrefix="select2-selection"
                        options={this.props.userLocation.map((item, index) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        value={{
                          label: this.props.filterdata?.locationlabel,
                          value: this.props.params?.location,
                        }}
                        onChange={(e) => {
                          this.props.getUserSubLocations(e.value);
                          this.props.FilterSelecteChangeValue({
                            key: "locationlabel",
                            label: e.label,
                            key2: "location",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label
                        htmlFor="Department-selection"
                        className="col-form-label"
                      >
                        Sub Location :
                      </Label>

                      <Select
                        id="Department-selection"
                        name="Department-selection"
                        classNamePrefix="select2-selection"
                        isDisabled={
                          this.props.params.location == null ? true : false
                        }
                        options={this.props.usersubLocation.map(
                          (item, index) => ({
                            label: item.name,
                            value: item.id,
                          })
                        )}
                        value={{
                          label: this.props.filterdata?.usersubLocationlabel,
                          value: this.props.params?.sublocation,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "usersubLocationlabel",
                            label: e.label,
                            key2: "sublocation",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup className="mb-0">
                      <Label
                        htmlFor="UserDepartment-selection"
                        className="col-form-label"
                      >
                        User Department :
                      </Label>

                      <Select
                        id="UserDepartment-selection"
                        name="UserDepartment-selection"
                        classNamePrefix="select2-selection"
                        options={this.props.userDeparment.map(
                          (item, index) => ({
                            label: item.name,
                            value: item.id,
                          })
                        )}
                        value={{
                          label: this.props.filterdata?.userdepartmentlabel,
                          value: this.props.params?.userdepartment,
                        }}
                        onChange={(e) => {
                          this.props.FilterSelecteChangeValue({
                            key: "userdepartmentlabel",
                            label: e.label,
                            key2: "userdepartment",
                            value: e.value,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col> */}
                </Row>

                <Row>
                  <Col className="mt-1">
                    <div className="float-right pt-1">
                      <Button
                        type="button"
                        color="light"
                        className="waves-effect waves-light mr-2"
                        onClick={this.clearFilter}
                      >
                        Clear
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={this.applyFilter}
                      >
                        Apply
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </SimpleBar>
          </div>
        </div>

        <div
          className="filters-right-bar-overlay"
          onClick={this.hideFilterRightbar}
        >
          {" "}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { userLocation, userDeparment, usersubLocation } = state.Mini;
  const { params, filterdata } = state.RequestForQuotation;

  return {
    userLocation,
    userDeparment,
    usersubLocation,
    params,
    filterdata,
  };
};

export default connect(mapStatetoProps, {
  getUserLocations,
  getUserSubLocations,
  getUserDepartment,
  FiltershideRightSidebar,
  FilterChangeValue,
  FilterSelectChangeValue,
  SetParams,
  getRFQRequestList,

  FilterClear,
})(FiltertRightbar);
